import { render, staticRenderFns } from "./contato-deficiente-visual.vue?vue&type=template&id=615adfd4&"
import script from "./contato-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./contato-deficiente-visual.vue?vue&type=script&lang=ts&"
import style0 from "./contato-deficiente-visual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615adfd4')) {
      api.createRecord('615adfd4', component.options)
    } else {
      api.reload('615adfd4', component.options)
    }
    module.hot.accept("./contato-deficiente-visual.vue?vue&type=template&id=615adfd4&", function () {
      api.rerender('615adfd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/contato-deficiente-visual.vue"
export default component.exports